import React from 'react';
import { ExternalLink } from '../../../components';
import { FormattedMessage } from '../../../util/reactIntl';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import css from '../TermsOfServicePage.module.css';

function ProfessionalTosGreek() {
  const history = useHistory();
  return (
    <div className="terms-page">
      <h1>Όροι Χρήσης για Επαγγελματίες & Experts</h1>

      <h2>ΠΛΗΡΟΦΟΡΙΕΣ ΕΓΓΡΑΦΟΥ</h2>
      <p>
        Ισχύει για: Επαγγελματίες Χρήστες (Παρόχους) που προσφέρουν υπηρεσίες μέσω της πλατφόρμας
        VivianLab
        <br />
        Τελευταία τροποποίηση: 5/12/2025
        <br />
        Σχετικά έγγραφα:{' '}
        <span
          role="button"
          className={css.termsLink}
          onClick={() => history.push('/terms-of-service?tab=consumer')}
        >
          Όροι Χρήσης για Καταναλωτές
        </span>{' '}
        | <ExternalLink href="/privacy-policy">Πολιτική Απορρήτου</ExternalLink> |{' '}
        <ExternalLink href="/data-processing-addendum">
          Σύμβαση Εκτέλεσης Επεξεργασίας (Παράρτημα 1)
        </ExternalLink>
      </p>

      <h2>Προοίμιο</h2>
      <p>
        Οι παρόντες Όροι Χρήσης εφαρμόζονται αποκλειστικά σε Επαγγελματίες & Experts (αναφερόμενους
        και ως «Πάροχοι»), οι οποίοι εγγράφονται και προσφέρουν υπηρεσίες μέσω των ιστοσελίδων
        www.vivianlab.gr, www.vivianlab.com και www.vivianlab.health, καθώς και των σχετικών
        εφαρμογών για κινητά (συλλογικά, η «Πλατφόρμα»).
      </p>
      <p>
        Η Πλατφόρμα ανήκει και λειτουργεί από την εταιρεία με την επωνυμία «VIVIANLAB LTD» και τον
        διακριτικό τίτλο «Vivian Lab», με έδρα 1612 SOFIA BUL. TSAR BORIS III № 81 ET.1, AP.1, VAT
        BG207933919, ηλεκτρονική διεύθυνση επικοινωνίας info@vivianlab.com (η «Εταιρεία»).
      </p>
      <p>
        Όλο το περιεχόμενο, τα εμπορικά σήματα και τα ονόματα χώρου (domains) (συμπεριλαμβανομένων
        των www.vivianlab.gr, www.vivianlab.com και www.vivianlab.health) αποτελούν αποκλειστική
        ιδιοκτησία της Εταιρείας και προστατεύονται από τη νομοθεσία περί πνευματικής ιδιοκτησίας,
        εμπορικών σημάτων και άλλων συναφών δικαιωμάτων διανοητικής ιδιοκτησίας.
      </p>
      <p>
        Η Εταιρεία δεσμεύεται να διασφαλίζει ότι η Πλατφόρμα είναι προσβάσιμη σε όλους τους χρήστες,
        συμπεριλαμβανομένων των ατόμων με αναπηρία, σύμφωνα με τον Ευρωπαϊκό Νόμο για την
        Προσβασιμότητα (Οδηγία (ΕΕ) 2019/882) και τα σχετικά τεχνικά πρότυπα.
      </p>

      <h2>1. ΟΡΙΣΜΟΙ</h2>
      <p>Για τους σκοπούς των παρόντων Όρων Χρήσης:</p>
      <ul>
        <li>
          <strong>«Επαγγελματίας Χρήστης» ή «Πάροχος»:</strong> Κάθε φυσικό ή νομικό πρόσωπο που
          είναι εγγεγραμμένο στην Πλατφόρμα και προσφέρει επαγγελματικές υπηρεσίες
          (συμπεριλαμβανομένων ειδικών υγείας, συμβούλων και επιχειρήσεων που δραστηριοποιούνται
          στον τομέα της υγείας και ευεξίας).
        </li>
        <li>
          <strong>«Καταναλωτής» ή «Χρήστης»:</strong> Κάθε άτομο που χρησιμοποιεί την Πλατφόρμα για
          να αναζητήσει, να κλείσει ή να λάβει υπηρεσίες ή ψηφιακό περιεχόμενο από Επαγγελματίες
          Χρήστες.
        </li>
        <li>
          <strong>«Πλατφόρμα» ή «Marketplace»:</strong> Το διαδικτυακό περιβάλλον που λειτουργεί από
          την Εταιρεία υπό το εμπορικό σήμα VivianLab και είναι προσβάσιμο μέσω ιστοσελίδας και
          εφαρμογών για κινητά.
        </li>
        <li>
          <strong>«Εταιρεία»:</strong> Η «VIVIANLAB LTD» με έδρα 1612 SOFIA BUL. TSAR BORIS III № 81
          ET.1, AP.1, VAT BG207933919, ηλεκτρονική διεύθυνση info@vivianlab.com, το νομικό πρόσωπο
          που κατέχει και λειτουργεί την Πλατφόρμα.
        </li>
        <li>
          <strong>«Υπηρεσίες»:</strong> Όλες οι διαμεσολαβητικές υπηρεσίες που παρέχει η Εταιρεία
          μέσω της Πλατφόρμας, συμπεριλαμβανομένης της προβολής προφίλ, της κράτησης ραντεβού, των
          βιντεοδιαβουλεύσεων, του εκπαιδευτικού περιεχομένου και των εργαλείων υποβοηθούμενων από
          Τεχνητή Νοημοσύνη (ΤΝ).
        </li>
        <li>
          <strong>«Συμφωνία»:</strong> Οι παρόντες Όροι Χρήσης, μαζί με την Πολιτική Απορρήτου και
          τη Σύμβαση Εκτέλεσης Επεξεργασίας (Data Processing Agreement).
        </li>
        <li>
          <strong>«Εργάσιμες Ημέρες»:</strong> Κάθε ημέρα πλην Σαββάτου, Κυριακής ή επίσημης αργίας
          στην Ελλάδα.
        </li>
        <li>
          <strong>«Συνεδρία» ή «Ραντεβού»:</strong> Προγραμματισμένη διαβούλευση ή παροχή υπηρεσίας
          μεταξύ Επαγγελματία Χρήστη και Καταναλωτή μέσω της Πλατφόρμας.
        </li>
        <li>
          <strong>«Επαγγελματικό Περιεχόμενο» (Professional Content):</strong> Κάθε πληροφορία,
          συμβουλή, σύσταση, εκπαιδευτικό υλικό ή άλλο περιεχόμενο (συμπεριλαμβανομένων όσων
          παρέχονται κατά τη διάρκεια webinars, συνεδριών, άρθρων, αναρτήσεων και βίντεο) που
          παρέχεται από τον Επαγγελματία Χρήστη μέσω της Πλατφόρμας ή σε συνεργασία με την Εταιρεία.
        </li>
        <li>
          <strong>«Συνδημιουργημένο Περιεχόμενο» (Co-Created Content):</strong> Κάθε περιεχόμενο
          (συμπεριλαμβανομένων, ενδεικτικά, βίντεο, webinars, διαδικτυακών μαθημάτων, άρθρων,
          περιεχομένου για μέσα κοινωνικής δικτύωσης, συνεντεύξεων και ηχογραφήσεων) που
          δημιουργείται από κοινού από τον Επαγγελματία Χρήστη και την Εταιρεία ή παράγεται από την
          Εταιρεία με τη συμμετοχή/παρουσία του Επαγγελματία Χρήστη.
        </li>
      </ul>

      <h2>2. ΑΠΟΔΟΧΗ ΤΩΝ ΟΡΩΝ</h2>
      <p>
        Με την εγγραφή ή χρήση της Πλατφόρμας, ο Επαγγελματίας Χρήστης αποδέχεται πλήρως και
        ανεπιφύλακτα ότι δεσμεύεται από:
      </p>
      <ol>
        <li>Τους παρόντες Όρους Χρήσης για Επαγγελματίες Χρήστες</li>
        <li>Την Πολιτική Απορρήτου</li>
        <li>Τη Σύμβαση Εκτέλεσης Επεξεργασίας (Παράρτημα 1)</li>
        <li>Την Πολιτική Cookies</li>
      </ol>
      <p>
        Εάν δεν αποδέχεστε τους όρους αυτούς, δεν πρέπει να εγγραφείτε ή να χρησιμοποιήσετε την
        Πλατφόρμα.
      </p>

      <h2>3. ΠΡΟΣΤΑΣΙΑ ΔΕΔΟΜΕΝΩΝ & ΡΟΛΟΙ ΣΤΟ ΠΛΑΙΣΙΟ GDPR</h2>
      <h3>3.1 Η Εταιρεία ως Υπεύθυνος Επεξεργασίας</h3>
      <p>
        Η Εταιρεία ενεργεί ως Υπεύθυνος Επεξεργασίας για τα προσωπικά δεδομένα που παρέχετε
        απευθείας στην Εταιρεία για σκοπούς όπως:
      </p>
      <ul>
        <li>Δημιουργία και διαχείριση λογαριασμού Επαγγελματία Χρήστη</li>
        <li>Επεξεργασία πληρωμών συνδρομών (εφόσον υφίστανται)</li>
        <li>Αποστολή ενημερωτικών δελτίων και προωθητικών επικοινωνιών (με τη συναίνεσή σας)</li>
        <li>Διαχείριση και ασφάλεια της Πλατφόρμας</li>
      </ul>
      <p>
        Όλες οι πληροφορίες σχετικά με τους σκοπούς επεξεργασίας, τις νομικές βάσεις, τη διάρκεια
        τήρησης, τους αποδέκτες δεδομένων και τα δικαιώματά σας ως υποκειμένου δεδομένων
        περιγράφονται αναλυτικά στην Πολιτική Απορρήτου.
      </p>
      <h3>3.2 Η Εταιρεία ως Εκτελών την Επεξεργασία</h3>
      <p>
        Όταν παρέχετε υπηρεσίες σε Καταναλωτές μέσω της Πλατφόρμας, εσείς (ο Επαγγελματίας Χρήστης)
        ενεργείτε ως Υπεύθυνος Επεξεργασίας για τα προσωπικά δεδομένα που σχετίζονται με αυτές τις
        υπηρεσίες (συμπεριλαμβανομένων δεδομένων ραντεβού, σημειώσεων συνεδριών και τυχόν δεδομένων
        υγείας).
      </p>
      <p>
        Σε αυτή την περίπτωση, η Εταιρεία ενεργεί ως Εκτελών την Επεξεργασία, συλλέγοντας και
        επεξεργαζόμενη τα δεδομένα αυτά αποκλειστικά για λογαριασμό σας και κατόπιν ρητών οδηγιών
        σας.
      </p>
      <p>
        Η νομική σχέση, τα μέτρα ασφαλείας και οι υποχρεώσεις επεξεργασίας ρυθμίζονται από τη
        Σύμβαση Εκτέλεσης Επεξεργασίας (DPA), η οποία προσαρτάται ως Παράρτημα 1 και αποτελεί
        αναπόσπαστο μέρος των παρόντων Όρων Χρήσης.
      </p>
      <p>
        Με την αποδοχή των παρόντων Όρων Χρήσης αποδέχεστε ταυτόχρονα και τη Σύμβαση Εκτέλεσης
        Επεξεργασίας (Παράρτημα 1).
      </p>

      <h3>
        <FormattedMessage id="ProfileImagesSection.titleWithNumber" values={{ number: '3.3' }} />
      </h3>
      <ul>
        <li>
          <FormattedMessage id="ProfileImagesSection.cameraAccess" />
        </li>
        <li>
          <FormattedMessage id="ProfileImagesSection.usage" />
        </li>
        <li>
          <FormattedMessage id="ProfileImagesSection.storage" />
        </li>
      </ul>

      <h2>4. ΔΙΑΔΙΚΤΥΑΚΕΣ ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΕΙ Η ΠΛΑΤΦΟΡΜΑ</h2>
      <p>
        Η Πλατφόρμα αποτελεί διαμεσολαβητική αγορά που εξειδικεύεται σε υπηρεσίες υγείας, ευεξίας
        και συναφείς συμβουλευτικές υπηρεσίες. Η Πλατφόρμα δεν παρέχει η ίδια ιατρικές, υγειονομικές
        ή επαγγελματικές υπηρεσίες· παρέχει μόνο τα τεχνικά μέσα μέσω των οποίων οι Επαγγελματίες
        Χρήστες συνδέονται με τους Καταναλωτές και τους παρέχουν υπηρεσίες.
      </p>
      <p>Οι υπηρεσίες που διατίθενται μέσω της Πλατφόρμας περιλαμβάνουν:</p>
      <ul>
        <li>
          Προβολή επαγγελματικού προφίλ (στοιχεία επικοινωνίας, προσόντα, ειδικότητες, παρεχόμενες
          υπηρεσίες, τιμές, ωράριο λειτουργίας)
        </li>
        <li>Ηλεκτρονική κράτηση ραντεβού</li>
        <li>Βιντεοδιαβουλεύσεις (μέσω Meet, Calendly ή του συστήματος της Πλατφόρμας)</li>
        <li>Ομαδικά webinars και γραμμές υποστήριξης (hotlines)</li>
        <li>Υπηρεσίες συνομιλίας (chat) και ανταλλαγής μηνυμάτων</li>
        <li>Εκπαιδευτικό περιεχόμενο (άρθρα, βίντεο, συνταγές)</li>
        <li>
          Εργαλεία υποβοηθούμενα από ΤΝ (παρακολούθηση συμπτωμάτων, εξατομικευμένη καθοδήγηση)
        </li>
      </ul>
      <p>
        Η Εταιρεία αναλαμβάνει να διασφαλίζει ότι η Πλατφόρμα και τα μέσα παροχής διαδικτυακών
        υπηρεσιών συμμορφώνονται με τους όρους της σύμβασης και είναι κατάλληλα για τους σκοπούς για
        τους οποίους χρησιμοποιούνται υπηρεσίες ψηφιακής διαμεσολάβησης, με την απαιτούμενη
        επαγγελματική επιμέλεια και δεξιότητα.
      </p>

      <h2>5. ΥΠΟΧΡΕΩΣΕΙΣ ΕΠΑΓΓΕΛΜΑΤΙΑ ΧΡΗΣΤΗ</h2>
      <h3>5.1 Απαιτήσεις Εγγραφής και Προφίλ</h3>
      <p>Οι Επαγγελματίες Χρήστες οφείλουν να:</p>
      <ul>
        <li>
          Παρέχουν ακριβείς, πλήρεις και ενημερωμένες πληροφορίες, συμπεριλαμβανομένων:
          <ul>
            <li>Ονοματεπώνυμου (ή επωνυμίας νομικού προσώπου)</li>
            <li>Επαγγελματικής διεύθυνσης και έδρας</li>
            <li>Στοιχείων επικοινωνίας (τηλέφωνο, email, ιστοσελίδα)</li>
            <li>
              Αριθμού άδειας άσκησης επαγγέλματος (όπως εκδίδεται από τον αρμόδιο επαγγελματικό
              σύλλογο ή ρυθμιστική αρχή)
            </li>
            <li>Επαγγελματικών προσόντων, πιστοποιήσεων και πεδίων εξειδίκευσης</li>
          </ul>
        </li>
        <li>
          Ενημερώνουν άμεσα το προφίλ τους σε περίπτωση αλλαγής στοιχείων, συμπεριλαμβανομένων
          ανανεώσεων ή λήξεων αδειών.
        </li>
      </ul>
      <p>
        Ο Επαγγελματίας Χρήστης φέρει αποκλειστική ευθύνη για την παροχή αληθών και ακριβών
        πληροφοριών και εγγυάται τόσο τη νομιμότητα όσο και τη νόμιμη κατοχή και χρήση τους. Ο
        Επαγγελματίας Χρήστης ευθύνεται για κάθε ζημία που ενδέχεται να υποστεί η Εταιρεία λόγω
        παραβίασης της υποχρέωσης αυτής.
      </p>
      <h3>5.2 Συμμόρφωση με Νομοθεσία και Επαγγελματικά Πρότυπα</h3>
      <p>Οι Επαγγελματίες Χρήστες οφείλουν να:</p>
      <ul>
        <li>
          Συμμορφώνονται με όλη την εφαρμοστέα εθνική, ευρωπαϊκή και διεθνή νομοθεσία,
          συμπεριλαμβανομένων ενδεικτικά:
          <ul>
            <li>Της νομοθεσίας για την προστασία καταναλωτή (Ν. 2251/1994, ΠΔ 131/2003)</li>
            <li>Της νομοθεσίας για το ηλεκτρονικό εμπόριο και τις ηλεκτρονικές επικοινωνίες</li>
            <li>Της νομοθεσίας για την προστασία δεδομένων (GDPR)</li>
            <li>Των επαγγελματικών κωδίκων δεοντολογίας και συμπεριφοράς</li>
          </ul>
        </li>
        <li>Δεν προβαίνουν σε παραπλανητική διαφήμιση ή αθέμιτο ανταγωνισμό</li>
        <li>
          Διασφαλίζουν ότι η τιμολόγηση συμμορφώνεται με τις απαιτήσεις διαφάνειας και οικονομικής
          νομοθεσίας
        </li>
        <li>Διατηρούν την αναγκαία επαγγελματική ασφάλιση για τις παρεχόμενες υπηρεσίες</li>
        <li>
          Εκδίδουν τα νόμιμα φορολογικά παραστατικά (αποδείξεις, τιμολόγια) προς τους Καταναλωτές
          και προς την Εταιρεία, όπου απαιτείται
        </li>
      </ul>
      <p>
        Η Εταιρεία δεν καθορίζει, δεν ελέγχει και δεν επαληθεύει την τιμολόγηση υπηρεσιών. Οι
        Επαγγελματίες Χρήστες φέρουν αποκλειστικά την ευθύνη για τον καθορισμό των αμοιβών τους και
        τη συμμόρφωση με την ισχύουσα νομοθεσία περί τιμολόγησης και διαφάνειας.
      </p>
      <h3>5.3 Παροχή Υπηρεσιών και Επαγγελματική Συμπεριφορά</h3>
      <p>Οι Επαγγελματίες Χρήστες οφείλουν να:</p>
      <ul>
        <li>Ανταποκρίνονται έγκαιρα σε επικοινωνίες από την Εταιρεία και τους Καταναλωτές</li>
        <li>Παρέχουν τις υπηρεσίες τους με επαγγελματισμό και επιμέλεια</li>
        <li>Διατηρούν την εμπιστευτικότητα όλων των πληροφοριών που λαμβάνουν από Καταναλωτές</li>
        <li>
          Μην κάνουν κακή χρήση των δεδομένων των Καταναλωτών για σκοπούς άλλους από την παροχή της
          συμφωνηθείσας υπηρεσίας
        </li>
        <li>Ενεργούν με καλή πίστη και επιχειρηματική ηθική</li>
      </ul>
      <p>Επαγγελματική συμβουλή και πληροφορίες</p>
      <p>Οι Επαγγελματίες Χρήστες αναγνωρίζουν και αποδέχονται ότι:</p>
      <ul>
        <li>
          Φέρουν αποκλειστική ευθύνη για όλες τις συμβουλές, πληροφορίες και περιεχόμενο που
          παρέχουν σε Καταναλωτές ή/και στο κοινό μέσω της Πλατφόρμας ή στο πλαίσιο οποιασδήποτε
          συνεργασίας με την Εταιρεία.
        </li>
        <li>
          Οφείλουν να διασφαλίζουν ότι όλες οι συμβουλές και πληροφορίες είναι ακριβείς,
          επικαιροποιημένες και σύμφωνες με την εφαρμοστέα νομοθεσία, τα επαγγελματικά πρότυπα και
          τους κώδικες δεοντολογίας.
        </li>
        <li>
          Δεν θα παρέχουν ιατρικές συμβουλές ή διάγνωση, εάν δεν διαθέτουν τη νόμιμη άδεια και
          εξουσιοδότηση προς τούτο, σύμφωνα με την κείμενη νομοθεσία.
        </li>
        <li>
          Παραμένουν πλήρως και αποκλειστικά υπεύθυνοι για οποιεσδήποτε συνέπειες απορρέουν από τις
          συμβουλές, τις συστάσεις ή τις παραλείψεις τους.
        </li>
      </ul>
      <p>
        Εάν Επαγγελματίας Χρήστης αποτύχει να παρέχει τη συμφωνηθείσα υπηρεσία εντός του
        καθορισμένου χρονικού πλαισίου, χωρίς προηγούμενη έγγραφη ειδοποίηση και έγκυρο λόγο, η
        Εταιρεία μπορεί, κατά την κρίση της, να αναστείλει ή να καταγγείλει την πρόσβασή του, να
        παρακρατήσει ή να επιστρέψει πληρωμές ή να λάβει άλλα κατάλληλα μέτρα. Επαναλαμβανόμενες ή
        αδικαιολόγητες παραλείψεις μπορεί να οδηγήσουν σε οριστική απομάκρυνση από την Πλατφόρμα
        ή/και σε νομικές ενέργειες.
      </p>
      <h3>5.4 Απαγόρευση Μη Εξουσιοδοτημένων Ραντεβού και Ακυρώσεων</h3>
      <p>
        Εάν Επαγγελματίας Χρήστης ακυρώσει τέσσερα (4) ή περισσότερα ραντεβού που έχουν
        προγραμματιστεί μέσω της Πλατφόρμας χωρίς έγκυρο λόγο, η Εταιρεία διατηρεί το δικαίωμα να
        καταγγείλει τη συνεργασία και να αφαιρέσει το προφίλ του από την Πλατφόρμα.
      </p>
      <h3>5.5 Ασφάλεια Λογαριασμού</h3>
      <p>
        Οι Επαγγελματίες Χρήστες είναι υπεύθυνοι για τη διατήρηση της εμπιστευτικότητας και
        ασφάλειας των στοιχείων πρόσβασής τους, συμπεριλαμβανομένων κωδικών πρόσβασης και στοιχείων
        ταυτοποίησης. Οφείλουν να επιλέγουν ισχυρούς, μοναδικούς κωδικούς και να λαμβάνουν εύλογα
        μέτρα προστασίας από μη εξουσιοδοτημένη πρόσβαση.
      </p>
      <p>
        Η Εταιρεία δεν ευθύνεται για οποιαδήποτε απώλεια ή ζημία που προκύπτει από αδυναμία
        συμμόρφωσης του Επαγγελματία Χρήστη με τις υποχρεώσεις αυτές.
      </p>

      <h2>6. ΤΙΜΟΛΟΓΗΣΗ, ΠΛΗΡΩΜΕΣ ΚΑΙ ΟΙΚΟΝΟΜΙΚΟΙ ΟΡΟΙ</h2>
      <h3>6.1 Τιμολόγηση Υπηρεσιών</h3>
      <ul>
        <li>Οι Επαγγελματίες Χρήστες καθορίζουν οι ίδιοι τις τιμές των υπηρεσιών τους.</li>
        <li>Η Εταιρεία δεν παρεμβαίνει σε αποφάσεις τιμολόγησης.</li>
        <li>
          Οι Επαγγελματίες Χρήστες φέρουν αποκλειστική ευθύνη για:
          <ul>
            <li>Τη συμμόρφωση των τιμών με την εφαρμοστέα οικονομική και διαφημιστική νομοθεσία</li>
            <li>
              Την έκδοση των νόμιμων φορολογικών παραστατικών (τιμολόγια, αποδείξεις) προς τους
              Καταναλωτές
            </li>
          </ul>
        </li>
      </ul>
      <p>
        Οι Επαγγελματίες Χρήστες μπορούν να προσφέρουν ομαδικές συνεδρίες ή γραμμές υποστήριξης
        δωρεάν ή με πληρωμή μέσω της Εταιρείας. Όσοι προσφέρουν δωρεάν ομαδικές συνεδρίες ή γραμμές
        υποστήριξης αναγνωρίζουν και αποδέχονται ότι φέρουν αποκλειστική ευθύνη για το περιεχόμενο
        και την παροχή των συνεδριών αυτών και δεν θα αναμένουν ή αξιώνουν οποιαδήποτε αποζημίωση ή
        πληρωμή από την Εταιρεία, υπό οποιεσδήποτε συνθήκες, συμπεριλαμβανομένων περιπτώσεων μη
        συμμετοχής Καταναλωτών.
      </p>
      <h3>6.2 Επεξεργασία Πληρωμών</h3>
      <p>
        Οι πληρωμές διεκπεραιώνονται μέσω Stripe, τρίτου παρόχου υπηρεσιών πληρωμής. Με την
        καταχώριση στοιχείων πληρωμής, οι Επαγγελματίες Χρήστες αποδέχονται τους Όρους και
        Προϋποθέσεις του Stripe.
      </p>
      <p>
        Η Εταιρεία δεν χειρίζεται άμεσα τις πληρωμές και δεν ευθύνεται για προβλήματα επεξεργασίας
        πληρωμών.
      </p>
      <p>Διαδικασία πληρωμής:</p>
      <ol>
        <li>
          Όταν ένας Καταναλωτής κλείνει ραντεβού, η πιστωτική του κάρτα προ-εγκρίνεται (δεν
          χρεώνεται).
        </li>
        <li>
          Εντός 7 ημερών μετά τη συνεδρία, ο Επαγγελματίας Χρήστης πρέπει να επιβεβαιώσει την
          ολοκλήρωση μέσω email ή της πλατφόρμας πληρωμών.
        </li>
        <li>
          Μετά την επιβεβαίωση, η κάρτα του Καταναλωτή χρεώνεται και τα χρήματα μεταφέρονται στον
          τραπεζικό λογαριασμό του Επαγγελματία Χρήστη εντός 5 εργάσιμων ημερών.
        </li>
      </ol>
      <p>
        Εάν ο Επαγγελματίας Χρήστης δεν επιβεβαιώσει την ολοκλήρωση εντός 7 ημερών, η Εταιρεία
        διατηρεί το δικαίωμα να επιστρέψει την πληρωμή στον Καταναλωτή. Ωστόσο, εάν ο Επαγγελματίας
        Χρήστης προσκομίσει αποδεικτικά ότι η συνεδρία πραγματοποιήθηκε, η Εταιρεία μπορεί, κατά την
        κρίση της, να προχωρήσει στην πληρωμή προς τον Επαγγελματία Χρήστη.
      </p>
      <h3>6.3 Επιστροφές Ποσών και Παρακράτηση Πληρωμών</h3>
      <p>
        Η Εταιρεία μπορεί να επιστρέψει το ποσό στον Καταναλωτή, εάν κρίνει, βάσει τεκμηριωμένων
        στοιχείων και αφού δώσει στον Επαγγελματία Χρήστη την ευκαιρία να απαντήσει, ότι η υπηρεσία
        δεν παρασχέθηκε ή δεν ολοκληρώθηκε όπως είχε συμφωνηθεί.
      </p>
      <p>
        Σε τέτοιες περιπτώσεις, ακόμη και εάν ο Επαγγελματίας Χρήστης έχει ήδη λάβει τα χρήματα, η
        Εταιρεία μπορεί να ζητήσει την επιστροφή τους για να τα αποδώσει στον Καταναλωτή, υπό την
        προϋπόθεση ότι η διαδικασία διεξάγεται σύμφωνα με την εφαρμοστέα νομοθεσία και με την
        κατάλληλη αιτιολόγηση και τεκμηρίωση.
      </p>
      <p>
        Η Εταιρεία θα παρέχει στον επηρεαζόμενο Καταναλωτή συνοπτική εξήγηση των λόγων για την
        απόφαση επιστροφής, κατόπιν αιτήματος, εκτός αν αυτό απαγορεύεται από τον νόμο ή είναι
        αναγκαίο για την αποτροπή απάτης.
      </p>
      <h3>6.4 Κουπόνια και Προωθητικές Πληρωμές</h3>
      <p>
        Όταν Καταναλωτής χρησιμοποιεί κουπόνι ή προωθητικό κωδικό που παρέχεται από την Εταιρεία, ο
        Επαγγελματίας Χρήστης πληρώνεται απευθείας από την Εταιρεία (και όχι από τον Καταναλωτή). Σε
        αυτές τις περιπτώσεις:
      </p>
      <ul>
        <li>
          Ο Επαγγελματίας Χρήστης οφείλει να εκδώσει τιμολόγιο ή παραστατικό παροχής υπηρεσίας (όχι
          απόδειξη λιανικής) προς την Εταιρεία εντός 7 ημερών από τη συνεδρία.
        </li>
        <li>
          Εάν το παραστατικό δεν εκδοθεί εντός της προθεσμίας, η Εταιρεία διατηρεί το δικαίωμα να
          αρνηθεί την πληρωμή.
        </li>
      </ul>
      <h3>6.5 Τεχνικές Αστοχίες</h3>
      <p>
        Εάν τεχνικό πρόβλημα εμποδίσει Επαγγελματία Χρήστη ή Καταναλωτή να συμμετάσχει σε
        προγραμματισμένη συνεδρία (π.χ. δυσλειτουργία της Πλατφόρμας, αποτυχία σύνδεσης), η Εταιρεία
        μπορεί, κατά την κρίση της, να ακυρώσει τη συνεδρία. Σε τέτοια περίπτωση:
      </p>
      <ul>
        <li>Δεν θα πραγματοποιηθεί χρέωση</li>
        <li>Ο Επαγγελματίας Χρήστης δεν δικαιούται πληρωμής</li>
        <li>Η συνεδρία μπορεί να επαναπρογραμματιστεί χωρίς επιπλέον κόστος</li>
      </ul>
      <p>Αυτό παραμένει στη διακριτική ευχέρεια της Εταιρείας.</p>
      <h3>6.6 Αυτοματοποιημένη Απόδειξη Παροχής Υπηρεσίας</h3>
      <p>
        Το αυτοματοποιημένο σύστημα της Εταιρείας εκδίδει εσωτερική απόδειξη παροχής υπηρεσίας για
        χρήση από την Εταιρεία. Η αυτοματοποιημένη αυτή απόδειξη δεν υποκαθιστά το φορολογικό
        παραστατικό (τιμολόγιο ή απόδειξη) που ο Επαγγελματίας Χρήστης οφείλει να εκδώσει βάσει της
        φορολογικής και λογιστικής νομοθεσίας.
      </p>

      <h2>7. ΔΙΚΑΙΩΜΑ ΥΠΑΝΑΧΩΡΗΣΗΣ (ΔΙΚΑΙΩΜΑΤΑ ΚΑΤΑΝΑΛΩΤΗ)</h2>
      <p>
        Οι Καταναλωτές δικαιούνται να υπαναχωρήσουν από προγραμματισμένο ραντεβού εντός 14
        ημερολογιακών ημερών από την ημερομηνία κράτησης, εκτός εάν:
      </p>
      <ul>
        <li>Η υπηρεσία έχει ήδη παρασχεθεί· ή</li>
        <li>
          Ο Καταναλωτής έχει ρητά συναινέσει στην έναρξη της υπηρεσίας εντός της περιόδου
          υπαναχώρησης και έχει αναγνωρίσει την απώλεια του δικαιώματος υπαναχώρησης.
        </li>
      </ul>
      <p>
        Για λήψη ψηφιακού περιεχομένου (όπως άρθρα, eBooks, βίντεο): Με τη λήψη, ο Καταναλωτής
        παραιτείται ρητά από το δικαίωμα υπαναχώρησης.
      </p>
      <p>Πολιτική ακύρωσης ραντεβού:</p>
      <ul>
        <li>Πάνω από 24 ώρες πριν το ραντεβού: Πλήρης επιστροφή χρημάτων</li>
        <li>
          Λιγότερο από 60 λεπτά πριν το ραντεβού: Επιβάλλονται τέλη ακύρωσης· δεν προβλέπεται
          επιστροφή χρημάτων
        </li>
      </ul>
      <p>
        Οι επιστροφές μπορεί να απαιτούν έως 14 εργάσιμες ημέρες για να εμφανιστούν στον λογαριασμό
        του Καταναλωτή, λόγω απαιτήσεων επεξεργασίας πληρωμών.
      </p>

      <h2>8. ΕΠΑΓΓΕΛΜΑΤΙΚΗ ΑΝΕΞΑΡΤΗΣΙΑ</h2>
      <h3>8.1 Ανεξάρτητοι Συνεργάτες</h3>
      <p>
        Οι Επαγγελματίες Χρήστες λειτουργούν ως ανεξάρτητοι συνεργάτες (independent contractors) και
        όχι ως υπάλληλοι, πράκτορες ή εταίροι της Εταιρείας.
      </p>
      <h3>8.2 Μη αποκλειστικότητα</h3>
      <p>
        Η Συμφωνία δεν δημιουργεί σχέση αποκλειστικότητας. Οι Επαγγελματίες Χρήστες μπορούν να
        παρέχουν υπηρεσίες σε τρίτους και να ασκούν άλλες επαγγελματικές δραστηριότητες.
      </p>
      <h3>8.3 Επαγγελματική ευθύνη</h3>
      <p>Οι Επαγγελματίες Χρήστες είναι αποκλειστικά υπεύθυνοι για:</p>
      <ul>
        <li>Το περιεχόμενο, την ποιότητα και την παροχή των υπηρεσιών τους</li>
        <li>
          Τις φορολογικές τους υποχρεώσεις, εισφορές κοινωνικής ασφάλισης και επαγγελματική ασφάλιση
        </li>
        <li>
          Την απόκτηση και διατήρηση όλων των απαιτούμενων αδειών, εγκρίσεων και πιστοποιήσεων
        </li>
      </ul>
      <p>
        Οι Επαγγελματίες Χρήστες δεν έχουν εξουσία να συνάπτουν συμβάσεις, να αναλαμβάνουν
        υποχρεώσεις ή να ενεργούν για λογαριασμό της Εταιρείας.
      </p>
      <p>Συνεργασίες Περιεχομένου</p>
      <p>
        Κατά διαστήματα, η Εταιρεία μπορεί να προσκαλεί Επαγγελματίες Χρήστες να συμμετέχουν σε
        πρωτοβουλίες δημιουργίας περιεχομένου, όπως webinars, masterclasses, ομαδικές συνεδρίες,
        ζωντανές μεταδόσεις (live streams, συμπεριλαμβανομένων σε Instagram και άλλα μέσα κοινωνικής
        δικτύωσης), συνεντεύξεις, podcasts ή δημιουργία εκπαιδευτικού υλικού. Η συμμετοχή σε τέτοιες
        δράσεις είναι προαιρετική, αλλά μόλις ο Επαγγελματίας Χρήστης συμφωνήσει να συμμετάσχει,
        κάθε Συνδημιουργημένο Περιεχόμενο που προκύπτει διέπεται από το Άρθρο 10.3 (Συνδημιουργημένο
        Περιεχόμενο και Ανατεθειμένο Υλικό). Ο Επαγγελματίας Χρήστης δεν μπορεί να ζητήσει αφαίρεση,
        απόσυρση ή περιορισμό της χρήσης του Συνδημιουργημένου Περιεχομένου, εκτός εάν αυτό
        απαιτείται από υποχρεωτική διάταξη νόμου.
      </p>

      <h2>9. ΑΠΑΓΟΡΕΥΜΕΝΗ ΣΥΜΠΕΡΙΦΟΡΑ</h2>
      <p>Οι Επαγγελματίες Χρήστες δεν επιτρέπεται να:</p>
      <ul>
        <li>Δημιουργούν ψεύτικους λογαριασμούς ή να εμπλέκονται σε δόλιες δραστηριότητες</li>
        <li>Συλλέγουν, αποθηκεύουν ή κάνουν κακή χρήση προσωπικών δεδομένων των Καταναλωτών</li>
        <li>Εμπλέκονται σε παραπλανητική διαφήμιση ή αθέμιτο ανταγωνισμό</li>
        <li>Χρησιμοποιούν προσβλητική, απειλητική ή διακριτική γλώσσα</li>
        <li>
          Παρενοχλούν Καταναλωτές ή άλλους χρήστες (η παρενόχληση περιλαμβάνει λεκτικές ή γραπτές
          εκφράσεις που αποσκοπούν σε ψυχική ή σωματική βλάβη)
        </li>
        <li>Ανεβάζουν κακόβουλο λογισμικό, ιούς ή επιβλαβές λογισμικό</li>
        <li>Αντιγράφουν, διανέμουν ή αναπαράγουν περιεχόμενο της Πλατφόρμας χωρίς έγγραφη άδεια</li>
        <li>
          Χρησιμοποιούν τα εμπορικά σήματα, το branding ή την εταιρική ταυτότητα της Εταιρείας χωρίς
          συναίνεση
        </li>
      </ul>
      <p>
        Οι βασικές αξίες που διέπουν την Πλατφόρμα είναι ο σεβασμός και η εκτίμηση. Απαγορεύεται
        αυστηρά κάθε μορφή διάκρισης βάσει φύλου, ταυτότητας φύλου, εθνικότητας, θρησκείας,
        αναπηρίας, σεξουαλικού προσανατολισμού ή ηλικίας.
      </p>
      <p>Εάν οι κανόνες αυτοί δεν τηρούνται, η Εταιρεία μπορεί να:</p>
      <ul>
        <li>Απενεργοποιήσει άμεσα τον λογαριασμό του Επαγγελματία Χρήστη</li>
        <li>Καταγγείλει τη Συμφωνία</li>
        <li>Επικοινωνήσει με τις αρμόδιες αρχές</li>
        <li>Επιδιώξει αποζημιώσεις και άλλα νόμιμα μέσα</li>
      </ul>

      <h2>10. ΔΙΚΑΙΩΜΑΤΑ ΠΝΕΥΜΑΤΙΚΗΣ ΙΔΙΟΚΤΗΣΙΑΣ</h2>
      <h3>10.1 Δικαιώματα της Εταιρείας</h3>
      <p>
        Όλο το περιεχόμενο, ο σχεδιασμός, τα εμπορικά σήματα, τα λογότυπα και το λογισμικό της
        Πλατφόρμας αποτελούν αποκλειστική ιδιοκτησία της Εταιρείας και προστατεύονται από τη
        νομοθεσία περί πνευματικής ιδιοκτησίας, εμπορικών σημάτων και λοιπών δικαιωμάτων διανοητικής
        ιδιοκτησίας.
      </p>
      <p>Οι Επαγγελματίες Χρήστες δεν επιτρέπεται να:</p>
      <ul>
        <li>
          Αντιγράφουν, αναπαράγουν, διανέμουν ή προβάλλουν περιεχόμενο της Πλατφόρμας χωρίς
          προηγούμενη έγγραφη άδεια
        </li>
        <li>
          Χρησιμοποιούν το εμπορικό σήμα ή το branding της Εταιρείας για την προώθηση προϊόντων ή
          υπηρεσιών τρίτων
        </li>
        <li>
          Προβαίνουν σε reverse engineering, αποσυναρμολόγηση ή παρέμβαση στο λογισμικό ή τα
          συστήματα της Πλατφόρμας
        </li>
      </ul>
      <p>
        Προστασία εμπορικού σήματος: Το «VivianLab» αποτελεί καταχωρημένο εμπορικό σήμα που
        προστατεύεται σύμφωνα με το Άρθρο 6α της Σύμβασης των Παρισίων και την Οδηγία (ΕΕ) 2015/2436
        του Ευρωπαϊκού Κοινοβουλίου και του Συμβουλίου της 16ης Δεκεμβρίου 2015 για την προσέγγιση
        των νομοθεσιών των κρατών μελών περί σημάτων.
      </p>
      <h3>10.2 Περιεχόμενο Προφίλ Επαγγελματία Χρήστη</h3>
      <p>
        Με την ανάρτηση περιεχομένου στο προφίλ σας (συμπεριλαμβανομένων φωτογραφιών, περιγραφών,
        άρθρων, βίντεο), εσείς:
      </p>
      <ul>
        <li>Διατηρείτε την κυριότητα του περιεχομένου</li>
        <li>
          Παρέχετε στην Εταιρεία μη αποκλειστική, παγκόσμια, χωρίς δικαιώματα χρήσης άδεια για
          χρήση, προβολή και διανομή του περιεχομένου σας στην Πλατφόρμα, με σκοπό την παροχή των
          Υπηρεσιών
        </li>
        <li>
          Εγγυάστε ότι διαθέτετε όλα τα απαραίτητα δικαιώματα για το περιεχόμενο αυτό και ότι δεν
          παραβιάζει δικαιώματα τρίτων
        </li>
      </ul>
      <h3>10.3 Συνδημιουργημένο Περιεχόμενο και Ανατεθειμένο Υλικό</h3>
      <ol>
        <li>
          <strong>Εκχώρηση Δικαιωμάτων Πνευματικης Ιδιοκτησίας</strong>
          <br />
          Στο μέτρο που επιτρέπεται από τον νόμο, ο Επαγγελματίας Χρήστης εκχωρεί, μεταβιβάζει και
          αποδίδει διά της παρούσας, αμετάκλητα και αποκλειστικά προς την Εταιρεία, όλα τα παγκόσμια
          δικαιώματα διανοητικής ιδιοκτησίας, συμπεριλαμβανομένων ενδεικτικά των πνευματικών
          δικαιωμάτων και συγγενικών δικαιωμάτων, επί κάθε Συνδημιουργημένου Περιεχομένου που
          παράγεται σε συνεργασία με την Εταιρεία (συμπεριλαμβανομένων, χωρίς περιορισμό, webinars,
          βιντεοσκοπήσεων, διαδικτυακών μαθημάτων, συνεντεύξεων, άρθρων, αναρτήσεων σε blogs,
          περιεχομένου για κοινωνικά δίκτυα, διαφημιστικού υλικού και κάθε οπτικοακουστικού υλικού
          στο οποίο εμφανίζεται ο Επαγγελματίας Χρήστης), για όλη τη διάρκεια προστασίας των
          δικαιωμάτων αυτών και για όλες τις χώρες παγκοσμίως.
        </li>
        <li>
          <strong>Άδεια σε περίπτωση που η εκχώρηση δεν είναι νομικά εφικτή</strong>
          <br />
          Όπου η εκχώρηση δεν είναι νομικά δυνατή, ο Επαγγελματίας Χρήστης παραχωρεί στην Εταιρεία
          αποκλειστική, παγκόσμια, διαρκή, αμετάκλητη, μεταβιβάσιμη και περαιτέρω αδειοδοτήσιμη
          άδεια χρήσης, αναπαραγωγής, τροποποίησης, προσαρμογής, μετάφρασης, διανομής, δημοσίευσης,
          δημόσιας εκτέλεσης, δημόσιας προβολής, παρουσίασης στο κοινό και κάθε άλλης μορφής
          εκμετάλλευσης του Συνδημιουργημένου Περιεχομένου, σε οποιαδήποτε μορφή και μέσω
          οποιουδήποτε μέσου, υφιστάμενου ή μελλοντικού, χωρίς καμία πρόσθετη αποζημίωση.
        </li>
        <li>
          <strong>Δικαίωμα επεξεργασίας, μετάφρασης και προσαρμογής</strong>
          <br />Η Εταιρεία δικαιούται να επεξεργάζεται, συντομεύει, προσαρμόζει, συνδυάζει με άλλο
          περιεχόμενο, να δημιουργεί παράγωγα έργα και να μεταφράζει το Συνδημιουργημένο Περιεχόμενο
          σε οποιαδήποτε γλώσσα, και να το χρησιμοποιεί για οποιονδήποτε εμπορικό, εκπαιδευτικό ή
          διαφημιστικό σκοπό, συμπεριλαμβανομένης, χωρίς περιορισμό, της παγκόσμιας διανομής μέσω
          της Πλατφόρμας, των μέσων κοινωνικής δικτύωσης, συνεργατών και διαφημιστικών καναλιών.
        </li>
        <li>
          <strong>Χρήση ονόματος, εικόνας και φωνής</strong>
          <br />Ο Επαγγελματίας Χρήστης παραχωρεί στην Εταιρεία το δικαίωμα χρήσης του ονόματός του,
          του επαγγελματικού του τίτλου, της εικόνας, της φωνής και της μορφής του, όπως αυτά
          ενσωματώνονται στο Συνδημιουργημένο Περιεχόμενο, αποκλειστικά για τους σκοπούς προώθησης
          και εκμετάλλευσης του περιεχομένου αυτού, σύμφωνα με την παρούσα ρήτρα.
        </li>
        <li>
          <strong>Μη πρόσθετη αποζημίωση</strong>
          <br />
          Εκτός εάν συμφωνηθεί ρητά διαφορετικά εγγράφως, ο Επαγγελματίας Χρήστης αναγνωρίζει ότι
          οποιαδήποτε συμφωνημένη αμοιβή ή εμπορική ρύθμιση για τη δημιουργία Συνδημιουργημένου
          Περιεχομένου καλύπτει πλήρως την αποζημίωσή του, και δεν δικαιούται σε οποιαδήποτε
          πρόσθετη πληρωμή, δικαιώματα ή συμμετοχή σε έσοδα που προκύπτουν από την εκμετάλλευση του
          Συνδημιουργημένου Περιεχομένου από την Εταιρεία.
        </li>
        <li>
          <strong>Ηθικά δικαιώματα</strong>
          <br />
          Στο μέτρο που επιτρέπεται από την εφαρμοστέα νομοθεσία, ο Επαγγελματίας Χρήστης
          παραιτείται (ή συμφωνεί να μην ασκήσει) κάθε ηθικό δικαίωμά του επί του Συνδημιουργημένου
          Περιεχομένου, συμπεριλαμβανομένων των δικαιωμάτων πατρότητας και ακεραιότητας του έργου,
          έναντι της Εταιρείας και των δικαιοδόχων, διαδόχων και εκδοχέων της.
        </li>
      </ol>

      <h2>11. ΠΕΡΙΟΡΙΣΜΟΣ ΕΥΘΥΝΗΣ</h2>
      <h3>11.1 Περιορισμός Ευθύνης της Εταιρείας</h3>
      <p>
        Η Πλατφόρμα παρέχεται αποκλειστικά για ενημερωτικούς και διαμεσολαβητικούς σκοπούς. Δεν
        παρέχει ιατρικές, υγειονομικές ή επαγγελματικές συμβουλές ή υπηρεσίες.
      </p>
      <p>Στο μέγιστο βαθμό που επιτρέπεται από τον νόμο:</p>
      <p>Η Εταιρεία δεν ευθύνεται για:</p>
      <ul>
        <li>
          Το περιεχόμενο, την ποιότητα ή το αποτέλεσμα των υπηρεσιών που παρέχονται από
          Επαγγελματίες Χρήστες
        </li>
        <li>Ακυρώσεις, μη εμφανίσεις ή μη ολοκληρωμένες συνεδρίες</li>
        <li>
          Οποιαδήποτε ζημία, απώλεια ή τραυματισμό που προκύπτει από υπηρεσίες ή αλληλεπιδράσεις
          μεταξύ Επαγγελματιών Χρηστών και Καταναλωτών
        </li>
        <li>Απώλεια εσόδων, κερδών, συμβάσεων ή ειδικές, έμμεσες ή επακόλουθες ζημίες</li>
      </ul>
      <p>
        Η Πλατφόρμα παρέχεται «ως έχει», χωρίς οποιαδήποτε εγγύηση, ρητή ή σιωπηρή,
        συμπεριλαμβανομένων, ενδεικτικά, εγγυήσεων εμπορευσιμότητας, καταλληλότητας για συγκεκριμένο
        σκοπό ή απρόσκοπτης λειτουργίας.
      </p>
      <p>
        Ωστόσο, ο παρών περιορισμός ευθύνης δεν αποκλείει ούτε περιορίζει την ευθύνη της Εταιρείας
        για:
      </p>
      <ul>
        <li>Θάνατο ή σωματική βλάβη που προκύπτει από δική της αμέλεια ή δόλο</li>
        <li>Οποιαδήποτε υποχρεωτική ευθύνη που δεν μπορεί να εξαιρεθεί από τον νόμο</li>
      </ul>
      <p>
        Για αποφυγή αμφιβολιών, η Εταιρεία δεν φέρει ευθύνη και δεν υπέχει καμία υποχρέωση
        αποζημίωσης για οποιαδήποτε συμβουλή, σύσταση, δήλωση ή παράλειψη εκ μέρους Επαγγελματιών
        Χρηστών κατά τη διάρκεια ατομικών συνεδριών, ομαδικών webinars, γραμμών υποστήριξης,
        εμφανίσεων σε μέσα κοινωνικής δικτύωσης ή σε οποιοδήποτε Επαγγελματικό Περιεχόμενο ή
        Συνδημιουργημένο Περιεχόμενο.
      </p>
      <h3>11.2 Αποζημίωση (Indemnification) από τον Επαγγελματία Χρήστη</h3>
      <p>
        Οι Επαγγελματίες Χρήστες συμφωνούν να αποζημιώνουν, υπερασπίζονται και διατηρούν την
        Εταιρεία αβλαβή έναντι κάθε:
      </p>
      <ul>
        <li>Αξίωσης, ευθύνης, ζημίας, απώλειας και δικαστικής απόφασης</li>
        <li>Εξόδων και δαπανών, συμπεριλαμβανομένων εύλογων νομικών και δικηγορικών αμοιβών</li>
      </ul>
      <p>που προκύπτουν από ή σχετίζονται με:</p>
      <ul>
        <li>Την παροχή υπηρεσιών από τον Επαγγελματία Χρήστη</li>
        <li>Παράβαση των παρόντων Όρων Χρήσης</li>
        <li>Παράβαση της εφαρμοστέας νομοθεσίας ή δικαιωμάτων τρίτων</li>
        <li>Αμέλεια ή δόλια συμπεριφορά</li>
        <li>
          Οποιαδήποτε αξίωση Καταναλωτή ή τρίτου σχετικά με συμβουλές, πληροφορίες ή περιεχόμενο που
          παρέχεται από τον Επαγγελματία Χρήστη, συμπεριλαμβανομένου Επαγγελματικού Περιεχομένου και
          Συνδημιουργημένου Περιεχομένου.
        </li>
      </ul>

      <h2>12. ΑΝΩΤΕΡΑ ΒΙΑ (Force Majeure)</h2>
      <p>
        Η Εταιρεία δεν ευθύνεται για αδυναμία εκπλήρωσης υποχρεώσεων όταν αυτή οφείλεται σε γεγονότα
        πέρα από τον εύλογο έλεγχό της, συμπεριλαμβανομένων, ενδεικτικά:
      </p>
      <ul>
        <li>Φυσικών καταστροφών (ανωτέρα βία)</li>
        <li>Πολέμου, τρομοκρατίας, πολιτικών αναταραχών</li>
        <li>Απεργιών ή ελλείψεων εργατικού δυναμικού</li>
        <li>Διακοπών σε δίκτυα επικοινωνίας</li>
        <li>Αδυναμίας λειτουργίας παρόχων πληρωμών</li>
        <li>Κυβερνητικών ενεργειών ή νομικών περιορισμών</li>
      </ul>
      <p>
        Σε περίπτωση γεγονότος ανωτέρας βίας, η Εταιρεία θα ενημερώνει τους επηρεαζόμενους
        Επαγγελματίες Χρήστες εντός 15 ημερών και θα παρέχει εκτίμηση της αναμενόμενης διάρκειας.
      </p>

      <h2>13. ΚΑΤΑΓΓΕΛΙΑ ΚΑΙ ΑΝΑΣΤΟΛΗ</h2>
      <h3>13.1 Καταγγελία από την Εταιρεία</h3>
      <p>
        Η Εταιρεία μπορεί να αναστείλει ή να τερματίσει άμεσα την πρόσβαση Επαγγελματία Χρήστη στην
        Πλατφόρμα, χωρίς προηγούμενη ειδοποίηση, εάν:
      </p>
      <ul>
        <li>Ο Επαγγελματίας Χρήστης παραβιάζει τους παρόντες Όρους Χρήσης</li>
        <li>Εμπλέκεται σε παράνομη, δόλια ή επιβλαβή δραστηριότητα</li>
        <li>
          Ο Επαγγελματίας Χρήστης ακυρώνει τέσσερα (4) ή περισσότερα ραντεβού χωρίς έγκυρο λόγο
        </li>
        <li>
          Η Εταιρεία λάβει δικαστική απόφαση, κυβερνητική εντολή ή ρυθμιστική ειδοποίηση που απαιτεί
          αναστολή ή τερματισμό
        </li>
        <li>Η συνέχιση παροχής υπηρεσιών θα εξέθετε την Εταιρεία σε νομικό ή κίνδυνο φήμης</li>
      </ul>
      <p>Γραπτή ειδοποίηση θα παρασχεθεί μετά την ενέργεια αυτή.</p>
      <h3>13.2 Καταγγελία από τον Επαγγελματία Χρήστη</h3>
      <p>Οι Επαγγελματίες Χρήστες μπορούν να καταγγείλουν τη Συμφωνία οποτεδήποτε:</p>
      <ul>
        <li>Κλείνοντας τον λογαριασμό τους μέσω των ρυθμίσεων της Πλατφόρμας· ή</li>
        <li>Αποστέλλοντας έγγραφη ειδοποίηση στην Εταιρεία στη δηλωμένη διεύθυνση επικοινωνίας</li>
      </ul>
      <p>
        Μετά την καταγγελία, η Εταιρεία θα διαγράψει ή θα επιστρέψει τα προσωπικά δεδομένα σύμφωνα
        με τη Σύμβαση Εκτέλεσης Επεξεργασίας (Παράρτημα 1) και την εφαρμοστέα νομοθεσία.
      </p>
      <h3>13.3 Συνέπειες Καταγγελίας</h3>
      <p>Με την καταγγελία:</p>
      <ul>
        <li>Ο Επαγγελματίας Χρήστης δεν θα έχει πλέον πρόσβαση στην Πλατφόρμα</li>
        <li>Όλες οι εκκρεμείς πληρωμές θα τακτοποιηθούν εντός εύλογου χρονικού διαστήματος</li>
        <li>
          Τα δεδομένα θα υποβληθούν σε επεξεργασία σύμφωνα με την Πολιτική Απορρήτου και τη Σύμβαση
          Εκτέλεσης Επεξεργασίας
        </li>
        <li>
          Ρήτρες που έχουν συμφωνηθεί ότι επιβιώνουν της καταγγελίας (συμπεριλαμβανομένων
          εμπιστευτικότητας, αποζημίωσης και ευθύνης) παραμένουν σε ισχύ
        </li>
      </ul>

      <h2>14. ΤΡΟΠΟΠΟΙΗΣΗ ΟΡΩΝ</h2>
      <p>
        Η Εταιρεία μπορεί να τροποποιεί τους παρόντες Όρους Χρήσης, την Πολιτική Απορρήτου και τις
        συναφείς πολιτικές ανά πάσα στιγμή για διάφορους νομικούς λόγους, όπως λόγους ασφαλείας,
        προστασίας διανοητικής ιδιοκτησίας, κανονιστικής συμμόρφωσης ή επιχειρηματικούς λόγους.
      </p>
      <p>
        Εάν μια τροποποίηση επηρεάζει ουσιωδώς και αρνητικά την πρόσβαση ή χρήση της Πλατφόρμας από
        Επαγγελματία Χρήστη, η Εταιρεία θα ενημερώσει εκ των προτέρων τον Επαγγελματία Χρήστη. Ο
        Επαγγελματίας Χρήστης θα έχει δικαίωμα να καταγγείλει τη Συμφωνία εντός 30 ημερών από την
        τροποποίηση.
      </p>
      <p>
        Η συνεχής χρήση της Πλατφόρμας μετά την έναρξη ισχύος των τροποποιήσεων συνιστά αποδοχή των
        τροποποιημένων όρων.
      </p>
      <p>
        Οι Επαγγελματίες Χρήστες μπορούν να αποθηκεύουν ή να διατηρούν αντίγραφο των Όρων κατά την
        εγγραφή τους.
      </p>

      <h2>15. ΕΚΧΩΡΗΣΗ ΔΙΚΑΙΩΜΑΤΩΝ</h2>
      <ul>
        <li>
          Οι Επαγγελματίες Χρήστες δεν μπορούν να εκχωρούν οποιαδήποτε δικαιώματα ή υποχρεώσεις
          βάσει της Συμφωνίας χωρίς την προηγούμενη έγγραφη συναίνεση της Εταιρείας.
        </li>
        <li>
          Η Εταιρεία μπορεί να εκχωρεί τα δικαιώματα και τις υποχρεώσεις της βάσει της Συμφωνίας σε
          οποιονδήποτε τρίτο, κατά την κρίση της (π.χ. σε περίπτωση συγχώνευσης, εξαγοράς ή
          μεταβίβασης της επιχείρησης).
        </li>
      </ul>

      <h2>16. ΔΙΚΑΙΟ ΚΑΙ ΔΙΚΑΙΟΔΟΣΙΑ</h2>
      <h3>16.1 Εφαρμοστέο Δίκαιο</h3>
      <p>
        Η παρούσα Συμφωνία διέπεται από το ελληνικό δίκαιο, ακόμη και όταν η Πλατφόρμα
        προσπελαύνεται από το εξωτερικό.
      </p>
      <h3>16.2 Επίλυση Διαφορών</h3>
      <p>
        Κάθε διαφορά που απορρέει από ή σχετίζεται με τη Συμφωνία υπάγεται αρχικά σε διαδικασία
        διαμεσολάβησης, σύμφωνα με τον Κανονισμό Διαμεσολάβησης του Υπουργείου Δικαιοσύνης.
      </p>
      <p>
        Εάν η διαφορά δεν επιλυθεί μέσω διαμεσολάβησης, επιλύεται αποκλειστικά μέσω διαιτησίας,
        σύμφωνα με Κανονισμούς Διαιτησίας, ή από τα Δικαστήρια Αθηνών, τα οποία έχουν αποκλειστική
        δικαιοδοσία.
      </p>
      <h3>16.3 Διαχωρισμός Όρων (Severability)</h3>
      <p>
        Εάν οποιαδήποτε διάταξη της Συμφωνίας κριθεί άκυρη ή ανεφάρμοστη από δικαστήριο, οι
        υπόλοιπες διατάξεις παραμένουν σε πλήρη ισχύ και ισχύουν κανονικά.
      </p>

      <h2>17. ΟΛΟΚΛΗΡΗ Η ΣΥΜΦΩΝΙΑ</h2>
      <p>
        Οι παρόντες Όροι Χρήσης, μαζί με την Πολιτική Απορρήτου και τη Σύμβαση Εκτέλεσης
        Επεξεργασίας (Παράρτημα 1), αποτελούν την πλήρη συμφωνία μεταξύ Επαγγελματία Χρήστη και
        Εταιρείας και υπερισχύουν κάθε προηγούμενης συμφωνίας, κατανόησης ή επικοινωνίας (γραπτής ή
        προφορικής) σχετικά με το αντικείμενό της.
      </p>
      <p>
        Κανένας άλλος όρος, προϋπόθεση ή δήλωση δεν δεσμεύει την Εταιρεία, εκτός εάν έχει συμφωνηθεί
        εγγράφως.
      </p>

      <h2>18. ΣΤΟΙΧΕΙΑ ΕΠΙΚΟΙΝΩΝΙΑΣ</h2>
      <p>
        Για ερωτήσεις ή απορίες σχετικά με τους παρόντες Όρους Χρήσης, μπορείτε να επικοινωνήσετε
        με:
      </p>
      <p>
        Εταιρεία: VIVIANLAB LTD
        <br />
        Διεύθυνση: 1612 SOFIA BUL. TSAR BORIS III № 81 ET.1, AP.1
        <br />
        Email: info@vivianlab.com
        <br />
        VAT: BG207933919
      </p>

      <h2>19. ΣΗΜΑΝΤΙΚΗ ΕΙΔΟΠΟΙΗΣΗ: ΣΕΒΑΣΜΟΣ & ΕΚΤΙΜΗΣΗ</h2>
      <p>
        Η Πλατφόρμα διέπεται από τις αξίες του σεβασμού και της εκτίμησης. Όλοι οι Επαγγελματίες
        Χρήστες οφείλουν να τηρούν τις αξίες αυτές σε όλες τους τις αλληλεπιδράσεις.
      </p>
      <p>Μηδενική ανοχή σε:</p>
      <ul>
        <li>Προσβλητική, προκλητική ή απειλητική γλώσσα</li>
        <li>
          Διακρίσεις λόγω φύλου, ταυτότητας φύλου, εθνικότητας, θρησκείας, αναπηρίας, σεξουαλικού
          προσανατολισμού ή ηλικίας
        </li>
        <li>Οποιαδήποτε μορφή παρενόχλησης</li>
      </ul>
      <p>Παραβάσεις μπορεί να οδηγήσουν σε απενεργοποίηση λογαριασμού ή/και νομικές ενέργειες.</p>

      <p>
        ΟΙ ΠΑΡΟΝΤΕΣ ΟΡΟΙ ΧΡΗΣΗΣ ΓΙΑ ΕΠΑΓΓΕΛΜΑΤΙΕΣ ΧΡΗΣΤΕΣ ΤΡΟΠΟΠΟΙΗΘΗΚΑΝ ΤΕΛΕΥΤΑΙΑ ΣΤΙΣ 5/12/2025
      </p>
      <p>
        Κάνοντας κλικ στο «Αποδέχομαι» ή χρησιμοποιώντας την Πλατφόρμα, δηλώνετε ότι έχετε διαβάσει,
        κατανοήσει και αποδέχεστε ότι δεσμεύεστε από τους παρόντες Όρους Χρήσης, την Πολιτική
        Απορρήτου και τη Σύμβαση Εκτέλεσης Επεξεργασίας (Παράρτημα 1).
      </p>
    </div>
  );
}

export default ProfessionalTosGreek;
